import { Outlet } from 'react-router-dom'
import Box from '@mui/material/Box'
import Navbar from './Navbar'
import Footer from './Footer'
import ArchivedOverlay from './ArchivedOverlay'

export default function Layout() {
	return (
		<Box sx={{ backgroundImage: "url('/images/BG Pattern.svg')" }}>
			{/* Overlay lives outside the disabled wrapper so its notice card
			    (and the Mithril link) stay fully interactive. */}
			<ArchivedOverlay />
			{/* Archived: disable interaction with the page's own links/buttons
			    while keeping the page scrollable (the document still scrolls). */}
			<Box sx={{ pointerEvents: 'none' }}>
				<Navbar />
				<Box>
					<Outlet />
				</Box>
				<Footer />
			</Box>
		</Box>
	)
}
